export default __webpack_public_path__ + "static/semicircle-gray-ffce0caf6964f2039154c79cd54b8798.svg";